import { render, staticRenderFns } from "./vip_packages.vue?vue&type=template&id=8a482406&scoped=true&"
import script from "./vip_packages.vue?vue&type=script&lang=js&"
export * from "./vip_packages.vue?vue&type=script&lang=js&"
import style0 from "./vip_packages.vue?vue&type=style&index=0&id=8a482406&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a482406",
  null
  
)

export default component.exports